import React from 'react';
import { DeepReadonly } from '@zajno/common/types';

import './style.sass';

import { CampaignData } from 'common/types/models/campaign';
import { UserInnerCard } from './UserInnerCard';

type Props = {
    campaigns: ReadonlyArray<DeepReadonly<CampaignData>>,
};

export const UserInnerCardsList = ({ campaigns }: Props) => {
    if (!campaigns || !campaigns.length) {
        return null;
    }

    return (
        <div className="user-inner-list">
            {campaigns.map(campaign => (
                <UserInnerCard
                    key={campaign.id}
                    campaignId={campaign.id}
                />
            ))}
        </div>
    );
};

